import { render, staticRenderFns } from "./VxPhone.vue?vue&type=template&id=eec31afc"
import script from "./VxPhone.vue?vue&type=script&lang=js"
export * from "./VxPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports